import Grid from "@material-ui/core/Grid";
import Skeleton from "@material-ui/lab/Skeleton";
import { WhiteSkeleton, useStyles } from "./TakisSkeleton.styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

const TakisSocialSkeleton = () => {
  const classes = useStyles();
  const theme = useTheme();
  const onMobile = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );
  return (
    <div className={classes.social_container}>
      <Skeleton variant="rect" className={classes.social_heading} />
      <Grid container spacing={0}>
        <Grid item xs={12} lg={6}>
          <div className={classes.left_container_bg}>
            <WhiteSkeleton variant="rect" className={classes.left_container} />
          </div>
        </Grid>
        <Grid item xs={12} lg={6}>
          <div className={classes.right_container}>
            <div className={classes.right_content}>
              <div className={classes.social_details_container}>
                <WhiteSkeleton
                  variant="rect"
                  className={`${classes.icon_container} ${classes.unset_icon}`}
                />
                <WhiteSkeleton
                  variant="rect"
                  className={classes.social_details_heading}
                />
                <WhiteSkeleton
                  variant="rect"
                  className={classes.social_details_p}
                />
                {!onMobile && (
                  <div className={classes.button_container}>
                    <WhiteSkeleton
                      variant="rect"
                      className={classes.social_button}
                    />
                  </div>
                )}
              </div>
              <WhiteSkeleton variant="rect" className={classes.social_image} />
            </div>
            {onMobile && (
              <div className={classes.button_container}>
                <WhiteSkeleton
                  variant="rect"
                  className={classes.social_button}
                />
              </div>
            )}
            <WhiteSkeleton
              variant="rect"
              className={`${classes.icon_container}`}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default TakisSocialSkeleton;
